import { render, staticRenderFns } from "./CrescimentoGrupoCulturaPrincipal.vue?vue&type=template&id=60afd6c6&"
import script from "./CrescimentoGrupoCulturaPrincipal.vue?vue&type=script&lang=js&"
export * from "./CrescimentoGrupoCulturaPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
